<template>
  <div>
    <ArInfoTop :productInfoItems="productInfoItems" :isLoading="isLoading"/>
    <ArInfoSearch :queryParams="queryParams" :productInfoItems="productInfoItems" :fullDate="fullDate" :selectProductOptCodeArr="selectProductOptCodeArr"/>
    <ArInfoList :queryParams="queryParams" :fieldItems="fieldItems" :fullDate="fullDate"/>
  </div>
</template>
<script>
import contentStatUserInfoModal from './ContentStatUserInfoModal';
import ArInfoTop from "./component/ArInfo/ArInfoTop";
import ArInfoSearch from "./component/ArInfo/ArInfoSearch";
import ArInfoList from "./component/ArInfo/ArInfoList";
const moment = require("moment");

/*Vue.filter('numberFormat', function(value) {
  if (typeof value !== 'number') {
    return value;
  }
  return value.toLocaleString(); // 3자리 콤마 적용
});*/

export default {
  components: {
    ArInfoList,
    ArInfoSearch,
    ArInfoTop,
    contentStatUserInfoModal
  },
  data() {
    return {
      isLoading: true,
      selectProductOptCodeArr: [],
      fullDate: [],
      productInfoItems: {},
      contentStatUserInfoOptions: {
        user_id: '',
        dr_code: '',
        view_type: '',
        start_date: '',
        end_date: '',
      },

      productcode: '',
      excelTotalCnt: 0,

      queryParams: {
        search_opt_code: '',
        keyword: '',
        p_code: '',
        product_name: '',
        view_type: 'VIEW',

        start_date: '',
        end_date: '',

      },

      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
      }, {
        'user_id': {
          'label': '아이디',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        },
        // 'visible': true,
      }, {
        'user_name': {
          'label': '이름',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'authority_name': {
          'label': '회원구분',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
          }
        }
      }, {
        'mobile': {
          'label': '핸드폰번호',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle',
          }
        },
      }, {
        'user_reg_date': {
          'label': '가입일',
          'class': 'text-center',
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }, {
        'total_cnt': {
          'class': 'text-center',
          'sortable': true,
          'thStyle': {
            'vertical-align': 'middle'
          }
        }
      }],
    }
  },
  computed: {

  },
  watch: {},
  mounted: function() {
    this.queryParams.p_code = this.$session.get('productcode');
    this.queryParams.product_name = this.$session.get('productName');
    this.contentArStatisticsTopInfo();
  },
  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
    chagefield(view_type){
      let label_nm = '';
      if (view_type == 'VIEW'){
        label_nm = '조회수';
      } else if (view_type == 'RECOMMAND'){
        label_nm = '추천수';
      } else if (view_type == 'DOWNLOAD'){
        label_nm = '다운로드수';
      } else if (view_type == 'RESEARCH'){
        label_nm = '후속연구요쳥수';
      }

      this.fieldItems = this.fieldItems.map(item => {
        if (item.hasOwnProperty('total_cnt')) {
          item.total_cnt.label = label_nm; // 'your_new_label'을 원하는 새로운 레이블로 바꾸세요.
        }
        return item;
      });
    },

    contentArStatisticsTopInfo(){
      var token = sessionStorage.getItem("myToken");
      var self = this;
      self.productcode = self.$session.get('productcode');
      self.$http.get('/api/select/contentArStatisticsTopInfo?access_token=' + token + '&productcode=' + self.productcode)
        .then((result) => {
          self.productInfoItems = result.data;
          self.isLoading = false;
          self.getDownLoadOptionCode();
        })
    },


    getDownLoadOptionCode(){
      var token = sessionStorage.getItem("myToken");
      var self = this;

      self.$http.get('/api/select/downloadArOptionCode?access_token=' + token + '&productcode=' + self.productInfoItems.p_code + '&ptype=' + self.productInfoItems.top_type_code)
        .then((result) => {
          var selectItems = result.data;
          console.log('result.data >>>',result.data);
          self.selectProductOptCodeArr = [];
          self.selectProductOptCodeArr.push({text: '전체',value: 'all'});
          selectItems.forEach(function (el, idx, arr){
            var items = {
              text: el.p_opt_name,
              value: el.p_opt_code,
            };
            self.selectProductOptCodeArr.push(items);
          });
          self.queryParams.search_opt_code = 'all';
        })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/statistics/content/ContentArStatisticsInfo.vue